import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Kpir } from '../../shared/models/kpir.model';
import { KpirPodsumowanie } from '../../shared/models/kpir-podsumowanie.model';
import { Sprzedaz } from '../../shared/models/sprzedaz.model';
import { SprzedazPodsumowanie } from '../../shared/models/sprzedaz-podsumowanie.model';
import { Zakup } from '../../shared/models/zakup.model';
import { ZakupPodsumowanie } from '../../shared/models/zakup-podsumowanie.model';
import { ZakresDat } from '../../shared/models/zakres-dat.model';
import { FormatowanieDatService } from '../utils';
import { Ryczalt } from '../../shared/models/ryczalt.model';

@Injectable({
  providedIn: 'root',
})
export class EwidencjaService {

  constructor(
    private http: HttpClient,
    private formatowanieDat: FormatowanieDatService,
  ) { }

  getKpir(zakresDat: ZakresDat) {
    return this.http.get<Kpir[]>('/api/ewidencja/kpir', { params: this.getParams(zakresDat) });
  }

  getKpirPodsumowanie(zakresDat: ZakresDat) {
    return this.http.get<KpirPodsumowanie[]>('/api/ewidencja/kpir-podsumowanie', { params: this.getParams(zakresDat) });
  }

  getSprzedaz(zakresDat: ZakresDat) {
    return this.http.get<Sprzedaz[]>('/api/ewidencja/sprzedaz', { params: this.getParams(zakresDat) });
  }

  getSprzedazPodsumowanie(zakresDat: ZakresDat) {
    return this.http.get<SprzedazPodsumowanie[]>('/api/ewidencja/sprzedaz-podsumowanie', { params: this.getParams(zakresDat) });
  }

  getZakup(zakresDat: ZakresDat) {
    return this.http.get<Zakup[]>('/api/ewidencja/zakup', { params: this.getParams(zakresDat) });
  }

  getZakupPodsumowanie(zakresDat: ZakresDat) {
    return this.http.get<ZakupPodsumowanie[]>('/api/ewidencja/zakup-podsumowanie', { params: this.getParams(zakresDat) });
  }

  getRyczalt(zakresDat: ZakresDat) {
    return this.http.get<Ryczalt[]>('/api/ewidencja/ryczalt', { params: this.getParams(zakresDat) });
  }

  getParams(zakresDat: ZakresDat) {
    return new HttpParams()
      .set('dataOd', this.formatowanieDat.format(zakresDat.dataOd))
      .set('dataDo', this.formatowanieDat.format(zakresDat.dataDo));
  }
}
